import {Component, OnDestroy, OnInit} from '@angular/core';
import {NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService} from '@nebular/theme';

import {LayoutService} from '../../../@core/utils';
import {map, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {UserService} from '../../../@core/api/users.service';
import {NbAuthJWTToken, NbAuthService} from '@nebular/auth';
import {UserDto} from '../../../@core/api/dto/users';
import {Router} from '@angular/router';
import {UserStateService} from "../../../@core/api/user.state.service";

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: UserDto;

  userMenu = [
    { title: 'Мій Профіль', data: { action: 'profile' } },
    { title: 'Вийти', data: { action: 'logout' } },
  ];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private themeService: NbThemeService,
              private userService: UserService,
              private authService: NbAuthService,
              private router: Router,
              public userStateService: UserStateService,
  ) {
  }

  ngOnInit() {
    this.authService.onTokenChange()
      .subscribe((token: NbAuthJWTToken) => {

        if (token.isValid()) {
          const tokenUserId = token.getPayload().userId;

          this.userService.getUser(tokenUserId)
            .pipe(takeUntil(this.destroy$))
            .subscribe((user: UserDto) => {
              this.userStateService.updateUser(user);
              this.user = user;
            });
        }
      });


    const {xl} = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.menuService.onItemClick()
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => this.onMenuItemClick(event.item));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onMenuItemClick(item) {
    if (item.data && item.data.action) {
      if (item.data.action === 'profile') {
        this.router.navigate(['/profile']);
      } else if (item.data.action === 'logout') {
        localStorage.clear();
        this.router.navigate(['/auth/login']);
      }
    }
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
}
